// ─── Color Palette Tokens ─────────────────────────────────────
// Each palette defines the full color system for a template.
// Templates reference palette IDs, never raw hex values.

export const palettes = {
  'ivory-gold': {
    id: 'ivory-gold',
    name: 'Ivory Gold',
    bg: '#F8F4EC',
    surface: '#FFFDF8',
    textPrimary: '#1F1A17',
    textSecondary: '#6E6256',
    accent: '#C8A96B',
    accentSoft: '#E8D8B8',
    border: '#E7DED0',
    buttonText: '#FFFFFF',
    buttonBg: '#1F1A17',
  },
  'rose-beige': {
    id: 'rose-beige',
    name: 'Rose Beige',
    bg: '#F6EFEC',
    surface: '#FFF8F6',
    textPrimary: '#2A2220',
    textSecondary: '#7A6862',
    accent: '#C88F8F',
    accentSoft: '#EBC9C3',
    border: '#E8DAD5',
    buttonText: '#FFFFFF',
    buttonBg: '#2A2220',
  },
  'forest-cream': {
    id: 'forest-cream',
    name: 'Forest Cream',
    bg: '#F5F3EC',
    surface: '#FFFDF8',
    textPrimary: '#1C241F',
    textSecondary: '#5C6B61',
    accent: '#556B5D',
    accentSoft: '#CDD7CF',
    border: '#DCE3DA',
    buttonText: '#FFFFFF',
    buttonBg: '#1C241F',
  },
  'black-champagne': {
    id: 'black-champagne',
    name: 'Black Champagne',
    bg: '#111111',
    surface: '#1A1A1A',
    textPrimary: '#F6F1E8',
    textSecondary: '#C9BBA5',
    accent: '#D4B06A',
    accentSoft: '#6E5B36',
    border: '#2A2A2A',
    buttonText: '#111111',
    buttonBg: '#F6F1E8',
  },
  // Legacy mappings for PremiumStory defaults
  'warm-story': {
    id: 'warm-story',
    name: 'Warm Story',
    bg: '#faf8f5',
    surface: '#ffffff',
    textPrimary: '#2c2420',
    textSecondary: '#8a8278',
    accent: '#c08081',
    accentSoft: '#e0b8b8',
    border: 'rgba(0,0,0,0.06)',
    buttonText: '#ffffff',
    buttonBg: '#c08081',
  },
  // Legacy mappings for NoirVinyl defaults
  'noir-gold': {
    id: 'noir-gold',
    name: 'Noir Gold',
    bg: '#000000',
    surface: '#1A1A1A',
    textPrimary: '#ffffff',
    textSecondary: '#888888',
    accent: '#d4af37',
    accentSoft: '#6E5B36',
    border: 'rgba(255,255,255,0.08)',
    buttonText: '#000000',
    buttonBg: '#d4af37',
  },
  'warm-paper': {
    id: 'warm-paper',
    name: 'Warm Paper',
    bg: '#f2ece6',
    surface: '#fffaf6',
    textPrimary: '#221c18',
    textSecondary: '#70655d',
    accent: '#9b7f6b',
    accentSoft: '#c4b09c',
    border: '#e7ddd3',
    buttonBg: '#221c18',
    buttonText: '#f2ece6',
  },
};
